import PartyMetaData from 'components/Dashboard/Analytics/ui/AnalyticsFilters/PartyMetadata';
import uppercaseFirstLetter, { capitalizeWords } from 'components/Dashboard/utilities/uppercaseFirstLetter';
import ConfigData from 'config/ConfigData';
import dayjs from 'dayjs';

const useAnalyticsCommonHelpers = () => {
  const createFilters = (dateInterval, view) => {
    if (dateInterval.length === 2) {
      return [
        {
          field: 'dateTime',
          value: dayjs(dateInterval[0]).startOf('day').format('YYYY-MM-DD'),
          operator: 'date_gte',
        },
        {
          field: 'dateTime',
          value: dayjs(dateInterval[1]).add('1', 'day').format('YYYY-MM-DD'),
          operator: 'date_lt',
        },
      ];
    } else {
      return [
        {
          field: 'dateTime',
          value: dayjs(dateInterval[0])
            .startOf(view ? view.toLowerCase() : 'day')
            .format('YYYY-MM-DD'),
          operator: 'date_gte',
        },
        {
          field: 'dateTime',
          value: dayjs().add('1', 'day').format('YYYY-MM-DD'),
          operator: 'date_lt',
        },
      ];
    }
  };

  const transformInterval = (interval) => {
    switch (interval) {
      case 'Day':
        return 'daily';
      case 'Week':
        return 'weekly';
      case 'Month':
        return 'monthly';
      default:
        return 'daily';
    }
  };

  const mergeResults = (targetArr, mergeArr) => {
    if (targetArr?.length > 0) {
      let result = targetArr?.map((item) => {
        let mergeItem = mergeArr?.find((datapoint) => datapoint.date === item.date);
        if (mergeItem) {
          return { date: item.date, value: item.value + mergeItem.value };
        } else {
          return item;
        }
      });
      return result;
    } else {
      return mergeArr;
    }
  };

  const createKey = ({ chartDataOption, item }) => {
    if (chartDataOption === 'Party') {
      let name = item
        .split(' ')
        .map((item) => uppercaseFirstLetter(item))
        .join(' ');
      let newName = PartyMetaData?.changeNames?.[name];
      if (newName) {
        name = newName;
      }
      return name;
    } else if (chartDataOption === 'Region') {
      if (item === 'yorkshire & the humber') {
        return 'Yorkshire and the Humber';
      } else {
        return item
          .split(' ')
          .map((item) => uppercaseFirstLetter(item))
          .join(' ');
      }
    } else if (chartDataOption === 'State') {
      return capitalizeWords(item);
    } else {
      switch (item) {
        case 'backbencher':
          return `Westminster Backbenchers`;
        case 'government':
          return 'Westminster Government';
        case 'shadow government':
          return 'Westminster Shadow Government';
        case 'ms':
          return 'MSs';
        case 'msp':
          return 'MSPs';
        case 'mla':
          return 'MLAs';
        default:
          return uppercaseFirstLetter(item);
      }
    }
  };

  const TweetsFilters = ConfigData?.analyticsTweetFilters;

  return { transformInterval, createFilters, mergeResults, createKey, TweetsFilters };
};

export default useAnalyticsCommonHelpers;
